
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";

@Component({
  components: {},
})
export default class About extends Vue {
  public about = [
    {
      id: "1",
      label: "API URL",
      value: process.env.VUE_APP_API_BASE_URL,
    },
    {
      id: "2",
      label: "Server Version",
      value: "---",
    },
    {
      id: "3",
      label: "Web AdminUI",
      value: process.env.VUE_APP_VERSION,
    },
  ];

  public mounted() {
    axios.get("/api/v4/Versions").then(
      (response) => {
        const d = response.data;
        this.about[1].value = d["Web-Services-Version"];
      },
      (error) => {}
    );
  }
}
